
import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  try {
    return (
      <SonnerToaster
        position="bottom-right"
        toastOptions={{
          className: "border-border",
          duration: 5000,
          style: {
            background: "hsl(var(--background))",
            color: "hsl(var(--foreground))",
            border: "1px solid hsl(var(--border))",
          },
        }}
      />
    );
  } catch (error) {
    console.warn('Toaster component error, returning null:', error);
    return null;
  }
}
